module.exports = __webpack_public_path__ + "static/video-1-placeholder-8caba31fcd6c840e5fa5f4046d8fb112.jpg";